import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    i: {
      text: 'This means the INTP tends to draw energy from solitude rather than from being around other people. Like all introverts, the INTP can come across as reserved in social situations',
    },
    n: {
      text: 'The INTP is focused on the realm of ideas, not the world of the senses. INTPs tend to be imaginative rather than practical',
    },
    t: {
      text: 'INTPs, like all personality types, have the ability to feel emotions. However, their go-to way of processing information and solving problems is via logical thought',
    },
    p: {
      text: 'This trait is correlated with open-mindedness and independence of thought. INTPs tend to be relatively easygoing in terms of how they live their lives and in terms of how they perceive other people',
    },
  },
  persons: [
    {
      slug: 'streep',
      name: 'Meryl Streep',
    },
    {
      slug: 'atkinson',
      name: 'Rowan Atkinson',
    },
    {
      slug: 'einstein',
      name: 'Albert Einstein',
    },
  ],
  advantages: [
    'Curiosity',
    'Depth',
    'Intuition',
    'Innovation',
  ],
  disadvantages: [
    'Reserve',
    'Coldness',
    'Disorganization',
    'Perfectionism',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'INTPs and friendships',
      text: 'The Logician is a unique and quirky companion; they offer great conversation, endless ideas, and a knack for seeing past superficial appearances.',
    },
    {
      color: 'red',
      title: 'INTPs and work',
      text: 'The Logician’s combination of creativity, dedication, and intellectual firepower means this personality type is suited to many different careers. Typically, INTPs are drawn toward jobs in the hard sciences, mathematics, and engineering, and they thrive in the world of tech.',
    },
    {
      color: 'mint',
      title: 'INTPs and romance',
      text: 'INTPs can appear detached and aloof, but still, waters run deep. In their relationships, INTPs have a pronounced romantic streak. Once they feel comfortable with someone they are passionate, loyal, playful, and full of surprises.',
    },
  ],
  aboutTypeDescription:
    'Each of the 16 Type Indicator types is made up of four letters, signifying a different combination of opposing traits: introversion vs extraversion, sensing vs intuition, thinking vs feeling, and perceiving vs judging.',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
        The INTP personality (also known as the Logician) is introverted,
        intuitive, thinking, and perceiving. Logicians comprise about 3% of the
        general population. They’re reserved, cool, and deeply curious about the
        world around them, and they take genuine joy in learning new things.
      </Text>
      <Text>
        Intuition drives the INTP to find and analyze patterns. Since this trait
        is combined with thinking, rather than feeling, this tendency stands
        them in particularly good stead in the fields of mathematics and
        science, and many great thinkers throughout the ages are believed to
        have had this personality type.
      </Text>
    </TypographyPage>
  ),
};
